import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AgingPeriodContainerComponent } from '../aging-period/aging-period-container/aging-period-container.component';
import { AgingPeriodListingComponent } from '../aging-period/aging-period-container/aging-period-listing/aging-period-listing.component';
import { AgingPeriodCreateComponent } from '../aging-period/aging-period-container/aging-period-create/aging-period-create.component';
import { AgingPeriodEditComponent } from '../aging-period/aging-period-container/aging-period-edit/aging-period-edit.component';
import { AgingPeriodEffects } from './aging-period-controller/effects/aging-period.effects';
import { agingPeriodFeatureKey } from './aging-period-controller/reducers/aging-period.reducers';
import { agingPeriodReducers } from './aging-period-controller/reducers/root';
import { SharedUtilitiesModule } from '../../utilities/shared-utilities.module';
import { AgingPeriodFacade } from './facades/aging-period.facade';
import { ViewCacheModule } from './view-cache.module';

export const agingPeriodAgGridModule = AgGridModule.withComponents([]);
export const agingPeriodStoreModule = StoreModule.forFeature(agingPeriodFeatureKey, agingPeriodReducers.agingPeriod);
export const agingPeriodEffectsModule = EffectsModule.forFeature([AgingPeriodEffects]);

@NgModule({
  declarations: [
    AgingPeriodContainerComponent,
    AgingPeriodListingComponent,
    AgingPeriodCreateComponent,
    AgingPeriodEditComponent
  ],
  imports: [
    CommonModule,
    ViewCacheModule,
    SharedUtilitiesModule,
    FormsModule,
    ReactiveFormsModule,
    agingPeriodAgGridModule,
    FlexLayoutModule,
    NgxMatSelectSearchModule,
    agingPeriodStoreModule,
    agingPeriodEffectsModule
  ],
  providers: [
    AgingPeriodFacade
  ]
})
export class AgingPeriodModule { }
